module.exports = __webpack_public_path__ + "img/10.18433550.jpg";